import { useState, useEffect } from "react";
import { Mesocycle } from "../types";
import { api } from "../services/api";

export const useMesocycles = (isAuthenticated: boolean) => {
  const [mesocycles, setMesocycles] = useState<Mesocycle[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (isAuthenticated) {
      fetchMesocycles();
    }
  }, [isAuthenticated]);

  const fetchMesocycles = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await api.mesocycles.getActive();
      setMesocycles(data);
    } catch (err) {
      console.error("Failed to fetch mesocycles:", err);
      setError("Failed to load mesocycles. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const createMesocycle = async (mesocycle: Omit<Mesocycle, "id">) => {
    try {
      const created = await api.mesocycles.create(mesocycle);
      setMesocycles((prev) => [...prev, created]);
      return created;
    } catch (err) {
      console.error("Failed to create mesocycle:", err);
      throw new Error("Failed to create mesocycle. Please try again.");
    }
  };

  const deleteMesocycle = async (id: string) => {
    try {
      await api.mesocycles.delete(id);
      setMesocycles((prev) => prev.filter((m) => m.id !== id));
    } catch (err) {
      console.error("Failed to delete mesocycle:", err);
      throw new Error("Failed to delete mesocycle. Please try again.");
    }
  };

  return {
    mesocycles,
    loading,
    error,
    createMesocycle,
    deleteMesocycle,
    refetch: fetchMesocycles,
  };
};
